<template>
  <div id="app">
    <v-app>
      <v-container class="cont mx-md-auto" justify-center>
        <img 
           :src="require('@/assets/logo.png')" alt="Logo" class="logo">
        <div
          class="wrapper mx-sm-5 mx-md-auto"
          d-sm-flex
          flex-sm-column-revesre
          d-xs-block
          flex-xs-wrap
          justify-space-between
        >
          <div class="item item-1">
            <FormComponent v-show="clicked" />
            <div
              v-show="!clicked"
              class="intro justify-center flex-column"
              style="height: 100%"
            >
              <h2 class="display-2 font-weight-bold text-uppercase">
                PMU Dermatology <br/> e-book for free
              </h2>
              <p class="custom-headline mt-5 secondary--text">
                I would like to receive <br> the free PMU Dermatology <br> e-book!
              </p>
              <v-btn
                class="mt-5 dl-button primary color-white"
                @click.prevent="() => (clicked = true)"
              >
                Download
              </v-btn>
            </div>
          </div>
          <div class="item item-2">
            <img
              class="magazin"
              :src="require('@/assets/landing_mockup_2.png')"
              alt="PMU Hungary Magazin"
            />
          </div>
        </div>
      </v-container>
    </v-app>
  </div>
</template>

<script>
  import FormComponent from "@/components/FormComponent";

  export default {
    name: "app",
    components: { FormComponent },
    data: () => ({
      clicked: false
    })
  };
</script>

<style lang="scss"> 
  html,
  body,
  #app {
    font-family: 'Montserrat', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #fff;

    .display-2 {
      font-family: 'Montserrat', sans-serif !important;
    }
  }

  #app {
    background-color: #B4D8C8;
    background-size: cover;

    @media (min-width: 992px) {
      background-image: url("assets/bg.jpg");
    }
  }

  .intro {
    display: flex;
  }

  h2 {
    text-align: left;
    line-height: 1.2em;
  }

  .custom-headline {
    font-size: 32px;
    font-weight: 600;
  }

  p {
    text-align: left;
  }

  .dl-button {
    max-width: 160px;
    margin-left: 0;
    background: white;
    border-radius: 11px;
    padding: 5px 30px;
    margin-top: 20px;
    color: #fff;
    font-weight: 400;
    font-size: 1.25rem;
    margin: 10px 0;
    letter-spacing: 0.09em;
    cursor: pointer;
    box-shadow: 2px 3px 8px 0px rgba(0, 0, 0, 0.3);
    letter-spacing: 0.1em;
  }

  .logo {
    position: absolute;
    left: 0;
    top: 20px;

    @media (max-width: 680px) {
      top: 15px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .item-1 {
    flex: 0 1 50%;
    align-self: center;

    @media (max-width: 680px) {
      left: -12px;
      position: relative;
      bottom: -12px;
    }

    @media (min-width: 680px) and (max-width: 960px) {
      flex: 0 1 49%;
    }

    @media (min-width: 960px) and (max-width: 1263px) {
      flex: 0 1 45%;
    }
  }

  .item-2 {
    flex: 0 1 48%;

    @media (max-width: 680px) {
      margin-top: 100px;
    }

    @media (min-width: 680px) and (max-width: 960px) {
      flex: 0 1 40%;
    }

    @media (min-width: 960px) and (max-width: 1263px) {
      flex: 0 1 45%;
    }
  }

  .cont {
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;

    @media (min-width: 1264px) {
      max-width: 1100px !important;
    }
  }

  .wrapper {
    display: flex;
    justify-content: space-between;
    max-width: 1100px;
    margin-left: auto;
    margin-right: auto;
    position: relative;

    @media (max-width: 680px) {
      flex-direction: column-reverse;
      height: auto;
    }
  }

  .magazin {
    max-width: 100%;
  }
</style>
